module.exports = __webpack_public_path__ + "img/next.0d83c5ff.svg";